export default __webpack_public_path__ + "static/media/tombstone.c6ae860a.png";